import { getOrgStats } from '@mesa/core/org/queries';
import { createServerFn } from '@tanstack/react-start';
import { assertScope, baseAuthMiddleware } from '../../middleware/base-auth';

export const loadSettingsPage = createServerFn({ method: 'GET' })
  .middleware([baseAuthMiddleware])
  .inputValidator((data: { orgSlug: string }) => data)
  .handler(async ({ context }) => {
    assertScope(context.member.role, 'admin');

    const stats = await getOrgStats(context.org.id);

    return {
      repoCount: stats.repoCount,
      apiKeyCount: stats.apiKeyCount,
      memberCount: stats.memberCount,
    };
  });
